import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as AhorroYCreditoActions from "app/@Content/components/AhorroYCredito/store/actions";
import TextTitleWithDownloads from "@components/TextTitleWithDownloads/TextTileWithDownloads";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";

const BORDER_TOP_COLOR = "#d7de00";

function Organizacion(props) {
  const dispatch = useDispatch();

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { token } = useSelector(({ Base }) => Base.Token);

  const { organizacion } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    dispatch(AhorroYCreditoActions.getOrganizacion(token));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defRoute = rutas?.filter((route) => route?.name === "Organizacion");
  const organizacionItems = (
    <>
      {organizacion && (
        <TextTitleWithDownloads
          title={organizacion?.aCOrganizacion[0]?.titulo}
          text={organizacion?.aCOrganizacion[0].descripcion?.html}
          borderTopColor={BORDER_TOP_COLOR}
          downloadSections={organizacion?.aCOrganizacion[0].bag.contentItems}
        />
      )}
    </>
  );

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.h1} />
      {organizacionItems}
    </>
  );
}

export default Organizacion;
